import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4l-4 2v5l4 2l4 -2v-5l-4 -2","key":"svg-0"}],["path",{"d":"M12 11l4 2l4 -2v-5l-4 -2l-4 2","key":"svg-1"}],["path",{"d":"M8 13v5l4 2l4 -2v-5","key":"svg-2"}]]

/**
 * IconCell
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2VsbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOCA0bC00IDJ2NWw0IDJsNCAtMnYtNWwtNCAtMiIgLz4KICA8cGF0aCBkPSJNMTIgMTFsNCAybDQgLTJ2LTVsLTQgLTJsLTQgMiIgLz4KICA8cGF0aCBkPSJNOCAxM3Y1bDQgMmw0IC0ydi01IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/cell
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCell = createReactComponent('outline', 'cell', 'Cell', __iconNode);

export default IconCell;